import React from "react";
import { Carousel } from "react-bootstrap";

const MotorBikeTraining = () => {

  
  return (
    <div className="roadRiderzProject">
      <h1 className="projects-Header">MotorBike Training Club</h1>
      <div className="row site-details-rrz">
        <div className="col-md-6 p-2">
          <p>* MotorBike Training Club create world class motor bike rider.</p>
          <p>
            * MotorBike Training Club provide best teacher for improve your
            skill and teach about traffic rules.
          </p>

          <p>* Medic_Nucleus team move to workshop every month.</p>
          <p>* This Site fully responsive for large and small device.</p>
          <p>* Implement simple functionalities with react router version-V.</p>
          <p>
            * Using technologies are ReactJS, ReactRouter, CSS3,React Bootstrap
            Netlify and implement Authorization system
          </p>
        </div>
        <div className="col-md-6 p-2">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/6mtHJC2/motorbike-Training-1.png"
                alt="First slide"
              />
              <Carousel.Caption>
                {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/6mtHJC2/motorbike-Training-1.png"
                alt="Second slide"
              />

              <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/6mtHJC2/motorbike-Training-1.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/6mtHJC2/motorbike-Training-1.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div className="siteInfo">
        <h3 className="seeLive">See Live: </h3>
        <span>
          {" "}
          <a
            className="liveSite"
            target="_blank"
            href="https://motorbike-training-club.netlify.app/ "
          >
            <b>LiveSite</b>
          </a>
        </span>
        <span>
          <a
            className="clientSide"
            target="_blank"
            href="https://github.com/Iasir-Arafat-riaz/MotorBike-TrainingClub-React-SPA"
          >
            <b>ClientSideCode</b>
          </a>
        </span>
        {/* <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/RoadRiderz-CustomX-NodeExpressServer-Heroku"><b>ServerSideCode</b></a>
        </span> */}
      </div>
    </div>
  );
};

export default MotorBikeTraining;
